module.exports = __webpack_public_path__ + "img/h2.aa1f855d.jpg";